import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  wrapper: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,

  content: css`
    display: flex;
    align-items: center;
    max-width: 100%;
  `,

  professionalInfo: ({ spacing }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: ${spacing.xs};
  `,

  arrowIcon: css`
    min-width: 24px;
    min-height: 24px;
  `,
})

export { useStyles }
